/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
//standard libraries
import { AxiosRequestConfig } from "axios";
import { SKIP_MESSAGE_SNACKBAR } from "../../constants/message";

//custom libraries
import { METHOD } from "../../constants/requests";
import { useRestService } from "./use-rest-service";

export const useFfmcentersHandler = () => {
  const { executeRequest } = useRestService();

  const getFfmcentersByTenant = () => {
    const requestOptions: AxiosRequestConfig | any = {
      method: METHOD.GET,
      url: "/ffmcenters/by-tenant",
      [SKIP_MESSAGE_SNACKBAR]: true,
    };

    return executeRequest(requestOptions);
  };

  const getFfmcentersByStore = (storeId: number) => {
    const requestOptions: AxiosRequestConfig | any = {
      method: METHOD.GET,
      url: `/ffmcenters/by-store/${storeId}`,
      [SKIP_MESSAGE_SNACKBAR]: true,
    };

    return executeRequest(requestOptions);
  };

  const getFfmcentersInventoryBySku = (sku: string) => {
    const requestOptions: AxiosRequestConfig | any = {
      method: METHOD.GET,
      url: `/ffmcenters/inventory/by-sku/${sku}`,
    };

    return executeRequest(requestOptions);
  };

  return {
    getFfmcentersByTenant,
    getFfmcentersByStore,
    getFfmcentersInventoryBySku,
  };
};
